import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import constants from "../../utils/constants";

import {
  CommonButton,
  CommonInput,
} from "../common/CommonElements";
import useForm from "../../hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../../redux/authSlice";
import { useNavigate } from "react-router-dom";
import { UpdatePasswordSchema } from "../../ValidationSchema/AuthValidations/updatePasswordSchema";
const UpdatePassword = () => {
  // !--------------------------- States ---------------------------
  const [formErrors, setFormErrors] = React.useState({});
  const dispatch = useDispatch();
  const { error, loading, token } = useSelector((state) => state.auth);

  // !--------------------------- Initialize form feilds ---------------------------
  const { values, handleChange} =
    useForm({
      password: "",
      password_confirmation: "",
    });

  const theme = useTheme();
  const navigate = useNavigate();
  // !--------------------------- Functions---------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors({});
  
    let filteredValues = { ...values };
   
    // console.log('filteredValues', filteredValues);
    const result = UpdatePasswordSchema.safeParse(filteredValues);
  
    if (!result?.success) {
      const errors = {};
      result?.error?.errors?.forEach((err) => {
        errors[err?.path[0]] = err?.message;
      });
      // console.log("errors", errors);
      setFormErrors(errors);
      return;
    } else {
      const result = await dispatch(updatePassword(filteredValues));
      if (updatePassword.fulfilled.match(result) || updatePassword.fulfilled.match(result)) {
        // Check for success response
        if (result?.payload?.code === 'SUCCESS') {
          // console.log('result payload', result.payload);
          navigate('/');
        } else {
          let errors = {};
          if (result?.payload?.errors) {
            const responseErrors = result?.payload?.errors;
            for (const field in responseErrors) {
              errors[field] = responseErrors[field][0];
            }
            // console.log('API validation errors', errors);
            setFormErrors(errors);
          } else {
            setFormErrors({ general: result?.payload?.message });
          }
        }
      } else {
        setFormErrors({ general: token ? 'Update failed. Please try again later.' : 'Registration failed. Please try again later.' });
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        mt: 2,
        overflow: "hidden",
      }}
    >
      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12} sm={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: 2,
              boxSizing: "border-box",
              overflow: "hidden",
              gap: 1,
              flex: 1,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: theme.palette.heading_color.main,
                fontWeight: 600,
                fontSize: { xs: 20, sm: 24 },
              }}
            >
              Update Password
            </Typography>
          
            <Box
              sx={{
                width: "100%",
                height: "1px",
                display: "flex",
                marginBottom: "8px",
                backgroundColor: theme.palette.seprator_color.main,
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
             
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "150px 1fr",
                        gap: 2,
                        alignItems: "center",
                        width: "100%",
                        padding: "8px 0",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          color: theme.palette.heading_color.main,
                          fontSize: { xs: 13, sm: 14 },
                        }}
                      >
                        {constants?.register?.password_section?.password_label}
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: 0,
                        }}
                      >
                        <CommonInput
                          placeholder={
                            constants?.register?.password_section
                              ?.password_placeholder
                          }
                          type="password"
                          value={values.password}
                          name="password"
                          onChange={handleChange}
                        />
                        {formErrors.password && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: theme.palette.primary.red,
                              textAlign: "left",
                              fontSize: { xs: 11, sm: 12 },
                              mt: 0.5,
                            }}
                          >
                            {formErrors.password}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "150px 1fr",
                        gap: 2,
                        alignItems: "center",
                        width: "100%",
                        padding: "8px 0",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          color: theme.palette.heading_color.main,
                          fontSize: { xs: 13, sm: 14 },
                        }}
                      >
                        {
                          constants?.register?.password_section
                            ?.confirm_password_label
                        }
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: 0,
                        }}
                      >
                        <CommonInput
                          placeholder={
                            constants?.register?.password_section
                              ?.confirm_password_placeholder
                          }
                          type="password"
                          value={values.password_confirmation}
                          name="password_confirmation"
                          onChange={handleChange}
                        />
                        {formErrors.password_confirmation && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: theme.palette.primary.red,
                              textAlign: "left",
                              fontSize: { xs: 11, sm: 12 },
                              mt: 0.5,
                            }}
                          >
                            {formErrors.password_confirmation}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <CommonButton
                  action={handleSubmit}
                  text={"Update"}
                  bgColor={theme.palette.secondary.main}
                  height="40px"
                  width="150px"
                  loading={loading}
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdatePassword;
